import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import $ from 'jquery'
import Scrollbar from 'smooth-scrollbar'
import Parallax from './modules/Parallax'
import Detect from './lib/Detect'
import 'magnific-popup'
const detect = Detect.getInstance()

// ScrollTriggerを利用できるようにする
gsap.registerPlugin(ScrollTrigger)

// smooth-scrollbar設定
const scroller = document.querySelector('.scroller')

const option = (detect.isPc())
        ? {damping: 0.15}
        : {damping: 0.08};
const bodyScrollBar = Scrollbar.init(scroller, option)

// モーダル
const modal = () => {
    $('.popup-katunou-1').magnificPopup({
        type: 'inline',
    });
    $('.popup-katunou-2').magnificPopup({
        type: 'inline',
    });
    $('.popup-huzzle-1').magnificPopup({
        type: 'inline',
    });
    $('.popup-huzzle-2').magnificPopup({
        type: 'inline',
    });
    $('.popup-game-1').magnificPopup({
        type: 'inline',
    });
    $('.popup-game-2').magnificPopup({
        type: 'inline',
    });
    $('.popup-crystal-1').magnificPopup({
        type: 'inline',
    });
    $('.popup-crystal-2').magnificPopup({
        type: 'inline',
    });
    $(document).on('click', '.js-popup-close', function (e) {
        e.preventDefault();
        $.magnificPopup.close();
    });
}

const anchor = () => {
    // アンカーリンク対応
    window.addEventListener('hashchange', function () {
        const hash = window.location.hash;
        if (hash) {
          const target = document.getElementById(hash.substring(1));
          if (target) {
            scrollbar.scrollIntoView(target, {
              offsetTop: -scrollbar.containerEl.scrollTop,
            });
          }
        }
    }, false);

    const slider = document.querySelector('#plan');
    let scrollToHere = slider.offsetTop;
    $('.plan__anchor').on('click', function() {
        bodyScrollBar.scrollTo(0, scrollToHere, 1000);
    });

    const slider2= document.querySelector('#task');
    let scrollToHere2 = slider2.offsetTop;
    $('.task__anchor').on('click', function() {
        bodyScrollBar.scrollTo(0, scrollToHere2, 1000);
    });

    const slider3= document.querySelector('#recall');
    let scrollToHere3 = slider3.offsetTop;
    $('.recall__anchor').on('click', function() {
        bodyScrollBar.scrollTo(0, scrollToHere3, 1000);
    });

}

// 慣性スクロール
const main = () => {
    // smooth-scrollbarとScrollTriggerの連携
    ScrollTrigger.scrollerProxy(scroller, {
        scrollTop(value) {
        if (arguments.length) {
            bodyScrollBar.scrollTop = value;
        }
        return bodyScrollBar.scrollTop;
        }
    })
    bodyScrollBar.addListener(ScrollTrigger.update)
    ScrollTrigger.defaults({ scroller })

    // マーカーポジション(markers: true)を smooth-scrollbar に対応させる
    // 開発時のみ利用
    if (document.querySelector('.gsap-marker-scroller-start')) {		
        const markers = gsap.utils.toArray('[class *= "gsap-marker"]');	
        bodyScrollBar.addListener(({ offset }) => {  
            gsap.set(markers, { marginTop: -offset.y })
        })
    }
}

const parallax = () => {
    // パララックス
    new Parallax(document.querySelector('.brain__kv'))
    new Parallax(document.querySelector('.brainAbout__logo'))
    new Parallax(document.querySelector('.brainAbout__inner'))
    new Parallax(document.querySelector('.brainAbout__right'))
    new Parallax(document.querySelector('.brainAbout__itemArea--sp'))
    new Parallax(document.querySelector('.brainAbout__playstyleBox'))
    new Parallax(document.querySelector('.brainProduct__kv'))
    new Parallax(document.querySelector('.brainProduct__kv--task'))
    new Parallax(document.querySelector('.brainProduct__kv--recall'))
    new Parallax(document.querySelector('.overview'))
    new Parallax(document.querySelector('.overview--task'))
    new Parallax(document.querySelector('.overview--recall'))
    new Parallax(document.querySelector('.brainProduct__text'))
    new Parallax(document.querySelector('.imgArea'))
    new Parallax(document.querySelector('.imgArea--task'))
    new Parallax(document.querySelector('.imgArea--recall'))
    new Parallax(document.querySelector('.brain__recommend'))
    new Parallax(document.querySelector('.brain__recommend--task'))
    new Parallax(document.querySelector('.brain__recommend--recall'))
    new Parallax(document.querySelector('.brainProduct__rightInner'))
    new Parallax(document.querySelector('.brainProduct__voiceArea'))
}

window.addEventListener('load', () => {
    // $('.l-brain').addClass('active')
    const scroller = document.querySelector('.scroller')
    scroller.style.width = '100%'
    scroller.style.height = '100vh'
    scroller.style.overflow = 'auto'
    main()
    parallax()
    modal()
    anchor()
    // // SPのheight 100vh対応
    $(document).ready(function () {
        let hsize = $(window).height();
        $(".scroller").css("height", hsize);
    });
})

window.addEventListener('resize', () => {
    // anchor() // アンカーリンクリサイズ毎に位置取得
    // // SPのheight 100vh対応
    $(document).ready(function () {
        let hsize = $(window).height();
        $(".scroller").css("height", hsize);
    });
})

const header = $('.l-header');

$(window).on('load', function () {
  $('a[href^="#"]:not(a.popup-tubelet,a.popup-yubiami,a.popup-funloom,a.popup-howto,a.popup-huzzle-1,a.popup-katunou-1,a.popup-katunou-2,a.popup-game-1,a.popup-game-2,a.popup-crystal-1,a.popup-crystal-2)').click(function () {
    const header_height = header.height();
    $('html,body').animate({
      scrollTop: $($(this).attr('href')).offset().top - header_height + 1
    }, 500);
    return false;
  })
});